import React, { useEffect, useState } from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import { useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from '../../constants/constants';
const DEFAULT = 'default';

const SearchByStatus = ({ setStatusValueAction, statusValueAction }) => {
  const [statusValue, setStatusValue] = useState(statusValueAction);
  const { path: pathname } = useRouteMatch();
  const getStatusesFilter = (pathname) => {
    switch (pathname) {
      case '/document':
        return [
          CONSTANTS.DOCUMENT.STATUS.INIT,
          CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN,
          CONSTANTS.DOCUMENT.STATUS.ERROR,
          CONSTANTS.DOCUMENT.STATUS.REJECTED
        ];
      case '/document/finished':
        return [
          CONSTANTS.DOCUMENT.STATUS.SIGNED,
          CONSTANTS.DOCUMENT.STATUS.CANCELLED
        ];
      case '/bundle':
        return Object.values(CONSTANTS.BUNDLE.STATUS).filter(status => status !== CONSTANTS.BUNDLE.STATUS.DELETED);
      default:
        return [];
    }
  };

  const getStatusFilter = (status) => {
    if (status === DEFAULT) {
      return null;
    }
    return status;
  };

  const onStatusChange = (event) => {
    const statusVal = event.target.value;
    const status = getStatusFilter(statusVal);
    const payload = { status };
    setStatusValue(statusVal);
    setStatusValueAction(payload);
  };

  const getStatusMenuItems = (statusFil, t) => {
    const menuItems = statusFil.map((status) => {
      return <MenuItem key={status} value={status}> {t(`documentSignStatus:${status}`)}</MenuItem>;
    });
    menuItems.unshift(<MenuItem selected key={DEFAULT} value={DEFAULT}> <em>{t('searchToolbar:allStatus')}</em></MenuItem>);
    return menuItems;
  };

  const statusFilters = getStatusesFilter(pathname);
  const { t } = useTranslation();
  const statusItems = getStatusMenuItems(statusFilters, t);

  useEffect(() => {
    if (statusValueAction === DEFAULT) {
      setStatusValue(DEFAULT);
    }
  }, [statusValueAction]);

  return (
    !!statusFilters.length &&
    <TextField
      id={'select-status-filter'}
      select
      value={statusValue}
      onChange={onStatusChange}
      label={t('searchToolbar:status')}
      variant='outlined'
      fullWidth
      InputLabelProps={{
        shrink: true
      }}
    >
      {statusItems}
    </TextField>
  );
};

export default SearchByStatus;
